export default {"src":"/_next/static/media/data-handling-optimization.c969ee08.svg","height":512,"width":576,"blurWidth":0,"blurHeight":0};